export default function route(page) {
  switch (page) {
    case 'data-set-list':
      import('./pages/data-set/data-set-list-page.js')
      return page

    case 'data-sensor-list':
      import('./pages/data-sensor/data-sensor-list-page.js')
      return page

    case 'data-sample':
      import('./pages/data-sample/data-sample-page.js')
      return page

    case 'data-samples':
      import('./pages/data-sample/data-samples-page.js')
      return page

    case 'data-sample-list':
      import('./pages/data-sample/data-sample-list-page.js')
      return page

    case 'data-sample-search':
      import('./pages/data-sample/data-sample-search-page.js')
      return page

    case 'data-summary-list':
      import('./pages/data-summary/data-summary-list-page.js')
      return page

    case 'data-summary-search':
      import('./pages/data-summary/data-summary-search-page.js')
      return page

    case 'data-summary-period':
      import('./pages/data-summary/data-summary-period-page.js')
      return page

    case 'data-report-samples':
      import('./pages/data-report/data-report-samples-page.js')
      return page

    case 'data-ooc':
      import('./pages/data-ooc/data-ooc-page.js')
      return page

    case 'data-oocs':
      import('./pages/data-ooc/data-oocs-page.js')
      return page

    case 'data-ooc-list':
      import('./pages/data-ooc/data-ooc-list-page.js')
      return page

    case 'data-entry-list':
      import('./pages/data-entry/data-entry-list-page.js')
      return page

    case 'data-report-list':
      import('./pages/data-report/data-report-list-page.js')
      return page

    case 'data-archive-list':
      import('./pages/data-archive/data-archive-list-page.js')
      return page

    // case 'jasper-report-samples':
    //   import('./pages/data-report/jasper-report-samples-page.js')
    //   return page

    // case 'jasper-report-samples-crosstab':
    //   import('./pages/data-report/jasper-report-samples-crosstab-page.js')
    //   return page

    // case 'jasper-report-oocs':
    //   import('./pages/data-report/jasper-report-oocs-page.js')
    //   return page

    // case 'data-report-embed':
    //   import('./pages/data-report/data-report-embed-page')
    //   return page

    case 'data-key-set-list':
      import('./pages/data-key-set/data-key-set-list-page.js')
      return page

    case 'data-summary-list':
      import('./pages/data-summary/data-summary-list-page')
      return page
  }
}
